import type { MapElement } from '../types/graph';

/**
 * Gets the maximum number of outcomes allowed for a map element type
 * @param elementType The map element type
 * @returns The maximum number of outcomes, or undefined for unlimited
 */
export const getMaxOutcomesForElementType = (elementType: string): number | undefined => {
    const lowerType = elementType.toLowerCase();

    switch (lowerType) {
        case 'approval':
            return 2;
        // Add other element types here as needed
        default:
            return undefined; // No limit
    }
};

/**
 * Checks if a map element can have additional outcomes added
 * @param mapElement The map element to check
 * @returns True if outcomes can be added, false if max reached
 */
export const canAddOutcome = (mapElement: MapElement | undefined): boolean => {
    if (!mapElement) {
        return true;
    }

    const maxOutcomes = getMaxOutcomesForElementType(mapElement.elementType);

    // No limit if maxOutcomes is undefined
    if (maxOutcomes === undefined) {
        return true;
    }

    const currentCount = mapElement.outcomes?.length ?? 0;
    return currentCount < maxOutcomes;
};
